{
	"exportCompletedGroupName": "Exported",
	"exportEmptyCompletedMessage": "No photos were exported.",
	"exportEmptyFailedMessage": "No failed photos.",
	"exportFailedGroupName": "Failed / Not Exported",
	"exportSummary": "{{completedCount}} photo(s) exported. {{failedCount}} photo(s) not exported.",
	"oversizeDescription": "These photos exceeded Pixieset's 100 MiB per-file limit. Reduce the export dimensions or quality before publishing them again; they cannot be retried as-is.",
	"oversizeEmptyMessage": "No oversized photos.",
	"oversizeGroupName": "Over 100 MiB / Not Published",
	"publishCompletedGroupName": "Published",
	"publishEmptyCompletedMessage": "No photos were published.",
	"publishEmptyFailedMessage": "No failed photos.",
	"publishFailedGroupName": "Failed / Not Published",
	"publishSummary": "{{completedCount}} photo(s) published. {{failedCount}} photo(s) not published."
}
